<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 15/02/2018-->
<!--//Time: 09:32-->
<script>

	import {Bar} from 'vue-chartjs';
	// import {_} from 'underscore';

	export default {
		name: "bar-chart",
		extends: Bar,
		components: {},
		props: ['chart_dataset'],
		created() {
		},
		destroyed() {
		},
		mounted() {
			let _this = this;

			//Setting the on click event
			_this.barOptions['onClick'] = function(){
				if (this.tooltip._active.length > 0){

					_this.$emit('on_bar_click', {
						index: this.tooltip._active[0]._index,
						label: this.tooltip._active[0]._model.label,
						dataset_index: this.tooltip._active[0]._datasetIndex
					});
				}
			}
		},
		data() {
			return {
				barOptions: {
					scales: {
						yAxes: [{
							stacked: true
						}],
						xAxes: [ {
							stacked: true
						}]
					},
					legend: {
						display: true
					},
					responsive: true,
                    maintainAspectRatio: false
                },
			}
		},
		methods: {},
		computed: {},
		watch: {
			chart_dataset(){
				this.renderChart(this.chart_dataset, this.barOptions);
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/BarChart.vue?5217ef11